module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    ref: "approot",
    style: ({
      width: _vm.ispreview ? '375px' : ''
    }),
    attrs: {
      "id": "approot"
    },
    on: {
      "dragover": _vm.allowDrop
    }
  }, [_c('div', [(_vm.logined && !_vm.ispreview) ? _c('div', {
    staticClass: "header",
    style: ({
      height: (_vm.headerh + "px"),
      'z-index': _vm.iseditor ? 1 : 100
    })
  }, [_c('img', {
    staticClass: "logo fl",
    attrs: {
      "src": _vm.logo,
      "title": _vm.page_title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "color": "#ccc",
      "padding-top": "17px"
    }
  }, [_vm._v(_vm._s(_vm.page_subtitle))]), _vm._v(" "), (_vm.logined) ? _c('div', {
    staticClass: "fr",
    staticStyle: {
      "line-height": "50px"
    }
  }, [(_vm.iseditor) ? [_c('label', {
    staticClass: "btnli",
    on: {
      "click": _vm.showFile
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wenjianguanli"
  }), _vm._v("\n\t\t\t\t文件管理")]), _vm._v(" "), _c('label', {
    staticClass: "btnli",
    on: {
      "click": _vm.showSetting
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shezhi"
  }), _vm._v("\n\t\t\t\t设置")]), _vm._v(" "), _c('label', {
    staticClass: "btnli",
    on: {
      "click": _vm.onSave
    }
  }, [_c('i', {
    staticClass: "iconfont icon-save"
  }), _vm._v("\n\t\t\t\t保存")])] : [(_vm.version.length) ? _c('Poptip', {
    attrs: {
      "trigger": "hover",
      "placement": "bottom",
      "word-wrap": "true",
      "width": "380"
    },
    on: {
      "on-popper-show": _vm.updateVersion
    }
  }, [(_vm.syslog.id) ? [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.syslog.created) + " V" + _vm._s(_vm.syslog.version))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "348px",
      "overflow": "hidden"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticStyle: {
      "line-height": "1.5",
      "font-size": "14px",
      "padding": "5px 0 8px",
      "white-space": "normal"
    }
  }, [_vm._v(_vm._s(_vm.syslog.remark))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "syslogs"
    }
  }, _vm._l((JSON.parse(_vm.syslog.content || '[]')), function(txt, idx) {
    return _c('li', {
      key: idx
    }, [_vm._v(_vm._s(txt))])
  }), 0), _vm._v(" "), _c('a', {
    staticClass: "syslog-history",
    attrs: {
      "href": _vm.logsmore,
      "target": "_blank"
    }
  }, [_vm._v("更多历史更新日志")])])] : [_c('p', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("未发现更新日志")])], _vm._v(" "), _c('Badge', {
    staticStyle: {
      "color": "#999",
      "margin-right": "15px"
    },
    attrs: {
      "dot": "",
      "count": _vm.vscnt
    }
  }, [_vm._v("更新日志")])], 2) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "helper",
    attrs: {
      "href": _vm.helper,
      "target": "_blank"
    }
  }, [_vm._v("帮助文档")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.loguser))]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-tuichu logout",
    attrs: {
      "title": "登出"
    },
    on: {
      "click": _vm.logout
    }
  })]], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.logined) ? _c('div', {
    staticClass: "main",
    style: ({
      'margin-top': _vm.ispreview ? '0px' : '50px',
      height: _vm.ispreview ? '100%' : ''
    })
  }, [(!_vm.ispreview) ? _c('div', {
    ref: "sidebar",
    class: ['sidebar', 'fl', {
      'editor-bar': _vm.iseditor
    }]
  }, [_c('sidebar', {
    attrs: {
      "iseditor": _vm.iseditor,
      "height": _vm.containerh
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content fl",
    style: (_vm.ctstyle)
  }, [(_vm.iseditor || _vm.ispreview) ? _c('weditor', {
    attrs: {
      "id": _vm.pageid,
      "height": _vm.containerh,
      "ispreview": _vm.ispreview
    }
  }) : _c(("Mc" + _vm.cmpalias), {
    tag: "component",
    attrs: {
      "type": _vm.cmptype
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.show_filedialog && !_vm.ispreview) ? _c('file-manager', {
    attrs: {
      "fmtype": _vm.filemgr_type,
      "con_height": _vm.con_height,
      "multiselect": _vm.filemgr_multiselect,
      "con_main_left_height": _vm.con_main_left_height
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.logined) ? _c('login') : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "温馨提示",
      "class-name": "vertical-center-modal",
      "closable": false,
      "mask-closable": false,
      "ok-text": "马上绑定",
      "cancel-text": "先体验一下"
    },
    on: {
      "on-ok": _vm.onBuild,
      "on-cancel": _vm.onTaste
    },
    model: {
      value: (_vm.buildAppTip),
      callback: function($$v) {
        _vm.buildAppTip = $$v
      },
      expression: "buildAppTip"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("部分功能需要授权绑定小程序后才能体验")])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "温馨提示",
      "class-name": "vertical-center-modal siterr",
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: (_vm.siteError),
      callback: function($$v) {
        _vm.siteError = $$v
      },
      expression: "siteError"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("抱歉，" + _vm._s(_vm.siteErrTips))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._v("  ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2de9151e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 185
// module chunks = 2